/**
 * Данные карты с главной → форма программы.
 *
 * Плашки «Твоей карты в программах» и левая колонка программ на главной
 * открывают программу с данными ТОЙ карты, что на экране. Раньше переход был
 * голой ссылкой, и программа подставляла своё: профиль аккаунта или
 * сохранённый ввод самой программы — у владельца на карте 15.05.1977 Харьков
 * открывалось 27.04.1988 Ухта.
 *
 * Данные едут в состоянии перехода (location.state), а не в адресе и не в
 * localStorage: только переход с плашки получает приоритет над профилем и
 * сохранённым вводом; обычный вход в программу из меню — как раньше.
 *
 * Источник — birthParams главной (useNatalCalculator): ровно то, что ушло на
 * сервер для показанной карты. Имени там нет, и полей имени в формах программ
 * тоже нет.
 */
export const HOME_HANDOFF_KEY = 'homeNatal';

const num = (v) => {
  const n = parseInt(v, 10);
  return Number.isNaN(n) ? null : n;
};

/** birthParams главной → нейтральная форма: числа, '' там, где пусто. */
export function handoffFromBirthParams(p) {
  if (!p) return null;
  const day = num(p.day);
  const month = num(p.month);
  const year = num(p.year);
  const lat = parseFloat(p.latitude);
  const lon = parseFloat(p.longitude);
  if (!day || !month || !year || Number.isNaN(lat) || Number.isNaN(lon)) return null;
  const timeUnknown = !!p.time_unknown;
  const [hh, mm] = String(p.time || '').split(':');
  const hour = timeUnknown ? null : num(hh);
  const minute = timeUnknown ? null : num(mm);
  const city = p.city && p.city !== 'Unknown' ? String(p.city) : '';
  const country = p.country && p.country !== 'Unknown' ? String(p.country) : '';
  return {
    day, month, year,
    hour: hour === null ? '' : hour,
    minute: minute === null ? '' : minute,
    timeUnknown: timeUnknown || hour === null || minute === null,
    city, country,
    latitude: lat, longitude: lon,
    timezone: p.timezone || '',
  };
}

/** Состояние для <Link state> / navigate(…, { state }). Демо-карту не передаём. */
export function homeHandoffState(birthParams, isDemo = false) {
  if (isDemo) return undefined;
  const data = handoffFromBirthParams(birthParams);
  return data ? { [HOME_HANDOFF_KEY]: data } : undefined;
}

/** Данные главной из перехода или null. */
export function readHomeHandoff(location) {
  const data = location && location.state && location.state[HOME_HANDOFF_KEY];
  if (!data || !data.day || !data.month || !data.year
      || data.latitude === undefined || data.longitude === undefined) return null;
  return data;
}

/** Убрать данные главной из истории после подстановки: обновление страницы
 *  или «назад-вперёд» не должны снова затирать то, что человек поправил. */
export function clearHomeHandoff(navigate, location) {
  if (!location || !location.state || !(HOME_HANDOFF_KEY in location.state)) return;
  const { [HOME_HANDOFF_KEY]: _drop, ...rest } = location.state;
  navigate(location.pathname + location.search + location.hash,
    { replace: true, state: Object.keys(rest).length ? rest : null });
}

const pad2 = (v) => (v === '' || v === null || v === undefined ? '' : String(v).padStart(2, '0'));
export { pad2 };
